module.exports = __webpack_public_path__ + "static/media/ps.915bb002.svg";